import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaValidationFramework from '@sparta.global.utilities/sparta-validation-framework-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import { textInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"visible") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":1},"end":{"line":45,"column":8}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"details") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":2},"end":{"line":44,"column":11}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "			<section class=\"wrapper-interactive-home-loans "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"margin")), depth0)) != null ? stack1 : "")
    + "\">\n				<div class=\"row\">\n					<div class=\"small-12 column\">\n            			<div class=\"row collapse\" data-equalizer>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":10},"end":{"line":39,"column":19}}})) != null ? stack1 : "")
    + "              			</div>\n					</div>\n				</div>\n			</section>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    							<div class=\"small-12 medium-6 column\" data-equalizer-watch>\n    								<img src='"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"img") : depth0)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + "' alt='"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"img") : depth0)) != null ? lookupProperty(stack1,"alt") : stack1), depth0))
    + "' aria-hidden=\"true\"/>\n    								<p class=\"interactive-header\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"header") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\n    								<div class='a-tag-city-state'>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"para") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":13},"end":{"line":20,"column":20}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"links") : depth0),{"name":"each","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":13},"end":{"line":23,"column":22}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cityStateInput") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":13},"end":{"line":36,"column":20}}})) != null ? stack1 : "")
    + "    								</div>\n    							</div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    										<p>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"para") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "    										<p>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    										<form id=\"validate-interactive-city-state-code\" novalidate>\n    											<div class=\"city-state-input\">\n    												"
    + ((stack1 = (lookupProperty(helpers,"textInput")||(depth0 && lookupProperty(depth0,"textInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"cityStateInput") : depth0)) != null ? lookupProperty(stack1,"inputInfo") : stack1),{"name":"textInput","hash":{},"data":data,"loc":{"start":{"line":27,"column":16},"end":{"line":27,"column":61}}})) != null ? stack1 : "")
    + "\n    											</div>\n\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"cityStateInput") : depth0)) != null ? lookupProperty(stack1,"buttonInfo") : stack1),{"name":"with","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":15},"end":{"line":34,"column":24}}})) != null ? stack1 : "")
    + "    										</form>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    												<div class='button-div'>\n    													<button id='"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"buttonId") : depth0), depth0))
    + "' type=\"button\" class='button spa-btn spa-btn--primary spa-btn--medium' role=\"button\" aria-label=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"adaLabel") : depth0), depth0))
    + "\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"buttonText") : depth0), depth0))
    + "</button>\n    												</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":0},"end":{"line":46,"column":9}}})) != null ? stack1 : "")
    + "\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/interactive-module",
  "version": "2.0.0",
  "id": "interactiveModule",
  "containerID": "homeLoansInteractiveModule",
  "moduleName": "home-loans-interactive-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "interactive-module",
  "data": {
    "init": "interactiveModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "margin",
    "type": "string",
    "default": "",
    "description": "To remove margin top for Mortgage & Refinance Page"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        textInput
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    textInput
  },
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-validation-framework-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-input-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/*
 * interactive-module
 * module_js_id: interactiveModuleJS
 *
 * Copyright (c) 2016-7-25
 */

/**
 * @class interactiveModule
 * @extends Module
 */
class interactiveModule extends Module {
  /**
   * @method constructor
   * @param {Object} options module params
   * @param {Object} context module params
   * @returns {void}
   */
  constructor(options, context) {
    // Extend Module
    super({
      ...options,
      context,
      config: _moduleConfig
    });

    // Jquery object for wrapper
    this.$target = $('#interactiveModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @method populateDefaultCityState
   * @desc populates default city state from eprofile call
   * @returns {void}
   */
  populateDefaultCityState() {
    const eprofile = this.Store.getData('eprofile');
    if (eprofile.residenceAddress) {
      const cityState = `${eprofile.residenceAddress.city}, ${eprofile.residenceAddress.state}`;
      this.$target.find('input').val(cityState).focusin();
    }
  }

  /**
   * @method submitFindAHome
   * @param {Object} e event object
   * @desc reads in city and state and forwards to page with query parm of city and state
   * @returns {void}
   * */
  submitFindAHome(e) {
    e.preventDefault();
    const $cache = this.$target.find(e.currentTarget);
    const $input = $cache.closest('form').find('input').first();
    const cityState = $input.val().trim();

    // ensure we are validated
    const isValidRequired = this.validationCore.validateRequiredFields($input);
    const isValidRules = this.validationCore.validateRules($input, this.validationRules[$input.attr('id')].change);
    if (!isValidRequired || !isValidRules) {
      return;
    }
    const arr = cityState.split(',');

    // double check to ensure we have a comma
    if (arr.length === 1) {
      return;
    }

    // last element is state
    const state = arr[arr.length - 1].trim().toUpperCase();

    // delete last element and city is rest of array
    arr.pop();
    const city = arr.join(',').trim().toUpperCase();

    // construct url
    const parm = `?city=${encodeURI(city)}&state=${encodeURI(state)}`;

    // get url
    const url = $input.attr('data-url');

    // if spanish page and we're validated then put on interstitial and update link
    if (/\/es/.test(window.location.pathname)) {
      $cache.attr('href', url + parm).addClass('spa-ui-layer-link spa-fn').attr('data-options', '{"interstitialType": "language-change", "interstitialBranding": "default"}');
    } else {
      // take to page
      window.location.href = url + parm;
    }
  }

  /**
   * @method triggerResize
   * @param {Object} e event object
   * @desc triggers resize on focusout if field is empty
   * @returns {void}
   */
  triggerResize(e) {
    const $cache = this.$target.find(e.currentTarget);
    const value = $cache.val() || '';

    // only run if value is empty
    const empty = value.length > 0 ? false : true; // eslint-disable-line
    if (empty) {
      // wait for parsley to run then trigge resize
      setTimeout(() => $(window).trigger('resize'), 200);
    }
  }

  /**
   * @method initializeValidation
   * @returns {void}
   */
  initializeValidation() {
    this.validationRules = _.fromPairs(this.$target.find('[data-validation-rules]').map(function ruleMap() {
      const $this = $(this);
      return [[$this.attr('id'), $this.data('validation-rules')]];
    }));
    this.validationCore = spartaValidationFramework.fn.core;
    this.validationCore.bindValidationRules(this.validationRules, true);
  }

  /**
   * @method init
   * @desc Initialize module
   * @returns {void}
   */
  init() {
    // remove data-default-pattern on inputs
    // Utility.inputRemovePatternDataAttr(this.$target);

    // sparta inputs
    this.$target.spartaInputs({
      validate: true
    });
    this.initializeValidation();

    // click on find a home go button
    this.$target.find('button.button').on('click', this.submitFindAHome);

    // form submit
    this.$target.find('form').on('submit', e => {
      e.preventDefault();
      this.submitFindAHome();
    });

    // fix for focus in on input, put nothing in,
    // then focusout and parsley error not contained in div (we need to trigger data equalizer)
    this.$target.find('input').on('focusout', this.triggerResize);
  }
}
registerModuleClass({
  moduleClass: interactiveModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { interactiveModule as default, moduleConfig };
